var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchBold = function SvgSearchBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.334 3.333a5 5 0 1 0 2.897 9.076l4.014 4.013a.833.833 0 0 0 1.178-1.178L12.41 11.23a5 5 0 0 0-4.076-7.897Zm-3.333 5a3.333 3.333 0 1 1 6.666 0 3.333 3.333 0 0 1-6.666 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearchBold;